import { DynamicContentType } from '../../types/content.types.js'
import { FileEntryBM } from '../../types/fileEntry.types.js'
import { LucideIconName } from '../../types/lucide.types.js'

export type DocumentData = {
  file?: FileEntryBM
  text: string
  marginBottom: string
}

export const document: DynamicContentType<DocumentData> = {
  name: 'document',
  viewName: 'Dokument',
  featureKey: 'document',
  icon: LucideIconName.FileText,
  uuid: '',
  default: true,
  data: {
    text: 'Dokument',
    marginBottom: '1rem',
  },
}
